
import {from as observableFrom} from 'rxjs';

import {catchError,  map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User } from '../user/user';
import { Apollo } from 'apollo-angular';

const CurrentUserQuery = require('./current-user.gql');
/**
 * Service to manage user session
 */
@Injectable()
export class SessionService {

  private _currentUser: Observable<User>;


  constructor(private http: HttpClient, private apollo: Apollo) {
    // Init current user
    this._currentUser = this.apollo.watchQuery({
      query: CurrentUserQuery
    })
    .valueChanges
    .pipe(map(({data}) => new User(data['currentUser'])));
  }


  logout(): Observable<void> {
    return this.http.delete('/auth')
    .pipe(
      map((res: any) => observableFrom([null]))
    ).pipe(
    catchError((err:any) => observableFrom([null])));
  }


  get currentUser() {
    return this._currentUser;
  }

  access_token(): Observable<string> {
    return this.http
    .get('/auth/access_token', {
      responseType: 'text'
    });
  }
}